export default __webpack_public_path__ + "static/media/img-0640-north-macedonia-full-face.b6d51e67.png";